import React from 'react';
import { useLocation } from 'react-router-dom';
import { ShieldCheck, LogIn } from 'lucide-react';
import { company } from '../../mock/mock';

const AdminLogin = () => {
  const location = useLocation();
  const error = location.state?.error;

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/admin';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[80vh] grid place-items-center bg-ktc-cream/50 px-6 py-16">
      <div className="w-full max-w-md bg-ktc-ivoryLight rounded-2xl border border-ktc-cream shadow-xl p-8 md:p-10 text-center">
        <img src={company.logo} alt="KTC" className="h-14 w-auto object-contain mx-auto" />
        <div className="h-12 w-12 grid place-items-center rounded-xl bg-ktc-green text-ktc-goldLight mx-auto mt-8">
          <ShieldCheck size={24} />
        </div>
        <h1 className="font-serif text-3xl font-semibold text-ktc-green mt-5">Admin Login</h1>
        <p className="text-sm text-ktc-charcoal/65 mt-2">Sign in with your authorised Google account to manage the website.</p>

        {error && <p className="text-sm text-red-600 bg-red-50 rounded-md py-2 px-3 mt-5">{error}</p>}

        <button
          onClick={handleLogin}
          className="w-full mt-7 inline-flex items-center justify-center gap-3 bg-ktc-green hover:bg-ktc-greenLight text-ktc-ivory font-medium px-6 py-3.5 rounded-md transition-colors"
        >
          <LogIn size={18} /> Continue with Google
        </button>
        <p className="text-xs text-ktc-charcoal/45 mt-5">Access is restricted to authorised administrators only.</p>
      </div>
    </div>
  );
};

export default AdminLogin;
